import styled from "styled-components";

export const HeaderFilter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`;

export const LogoutSection = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px;
    
    button {
        width: max-content;
        padding: 16px;
    }
`;

